<template>
  <div>
    <Card
      title="Account Deletion Survey"
    >
      <template v-slot:button>
        <Button v-if="isEdit" @clicked="cancelEdit" variant="default" label="Cancel" />
        <Button  @clicked="actionEdit" variant="primary" :label="textButtonEdit" />
      </template>
      <template v-slot:body>
        <div class="flex flex-col">
          <h5 class="text-gray-700 text-sm mt-3 mb-6 font-bold uppercase text-left">
            Account Deletion Survey Form
          </h5>
          <form-item label='Title'>
            <template v-slot>
              <div class="relative" >
                <Input
                  v-model="title"
                  :disabled="!isEdit"
                  placeholder="Input Title"
                  :error="$v.title.$dirty && !$v.title.required"
                  maxlength="25"
                />
                <div  class="absolute right-0 text-xs" style="top: 15px; right: 15px;" >{{title.length}}/25</div>
              </div>
              <div class="flex flex-col pt-2">
                <text-error v-if="$v.title.$dirty && !$v.title.required" text="Please fill Title." />
              </div>
            </template>
          </form-item>
          <form-item label='Description'>
            <template v-slot>
              <div class="relative" >
                <TextArea
                  v-model="description"
                  :disabled="!isEdit"
                  placeholder="Input Description"
                  :error="$v.description.$dirty && !$v.description.required"
                  maxlength="128"
                  rows="2"
                />
                <div  class="absolute right-0 text-xs" style="bottom: 15px; right: 15px;" >{{description.length}}/128</div>
              </div>
              <div class="flex flex-col pt-2">
                <text-error v-if="$v.description.$dirty && !$v.description.required" text="Please fill Description." />
              </div>
            </template>
          </form-item>
        </div>
        <div class="flex border-b border-gray-200 py-3 justify-between">
          <div class="flex flex-col">
            <h5 class="text-gray-700 text-sm py-2 font-bold uppercase">
              Options
            </h5>
            <text-error v-if="$v.listOptions.$dirty && !$v.listOptions.minLength" text="Options at least have 2 item"/>
          </div>
        </div>
        <el-table-draggable  handle=".handle-move" :disabled="!isEdit"  v-if="listOptions.length > 0" >
          <el-table :data="listOptions" row-key="id" :show-header="false" style="width: 100%">
            <el-table-column label="Handle" align="center" key="handle" width="100px">
              <div class="static inline-block text-center container-action handle-move" style="cursor: move">
                <font-awesome-icon size="2x" :icon="['fa', 'th']" />
              </div>
            </el-table-column>
            <el-table-column label="Actions" align="left" width="450px">
              <template slot-scope="scope">
                <div class="static inline-block text-left container-action w-full">
                  <div class="relative">
                    <input type="text" class="block border border-grey-light w-full p-3 rounded"
                           :class=" ($v.listOptions.$each[scope.$index].name.$dirty && !$v.listOptions.$each[scope.$index].name.required) ? 'border-red-500' : ''"
                           v-model.trim="$v.listOptions.$each[scope.$index].name.$model"
                           maxlength="36"
                           :disabled="!isEdit"
                    />
                    <div v-if="isEdit" class="absolute right-0 text-xs" style="top: 15px; right: 15px;" >{{listOptions[scope.$index].name.length}}/36</div>
                  </div>

                  <p v-if="$v.listOptions.$each[scope.$index].name.$dirty && !$v.listOptions.$each[scope.$index].name.required" class="text-red-500 text-xs italic text-left">Please fill the Option.</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Actions" align="left" width="350px">
              <template slot-scope="scope">
                <div class="static inline-block text-left container-action w-full">
                  <div v-if="isEdit">
                    <input type="checkbox" v-model="listOptions[scope.$index].show_text_field"/>&nbsp;<span>Show text field when user pick this option</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Actions" align="right">
              <template slot-scope="scope">
                <div class="static inline-block text-left container-action">
                  <VueCustomTooltip label="Delete" :position="'is-left'" v-if="isEdit">
                    <button @click="del(scope)" class="p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                    </button>
                  </VueCustomTooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-table-draggable>
        <button
          v-if="isEdit"
          :disabled="maxOptions"
          @click="addOption"
          class="text-sm focus:outline-none px-4 py-2 rounded font-bold cursor-pointer w-full
                              border duration-200 ease-in-out transition"
        :class="maxOptions?'border-gray-600 bg-gray-700 text-gray-100 hover:bg-gray-100 hover:text-gray-700':'border-blue-600 bg-blue-700 text-blue-100 hover:bg-blue-100 hover:text-blue-700'"
        >Add Option</button>
      </template>
    </Card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import ElTableDraggable from 'el-table-draggable';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import Card from '@/components/Layout/Card';
import { FormItem, Button, TextError, Input, TextArea } from '@/components/Layout/Form';

export default {
  name: 'AccountDeletionSurvey',
  mixins: [validationMixin],
  data: () => ({
    listOriginOptions: [],
    listOptions: [],
    title: '',
    description: '',
    isEdit: false,
    lastId: 0,
  }),
  validations() {
    const rules =
      {
        title: {
          required,
        },
        description: {
          required,
        },
      };
    rules.listOptions = {
      required,
      minLength: minLength(2),
      $each: {
        name: {
          required,
        },
      },
    };
    return rules;
  },
  computed: {
    ...mapGetters('NotificationModule', ['getErrorCode', 'getMessage', 'getStatus']),
    textButtonEdit() {
      return this.isEdit ? 'Save' : 'Edit';
    },
    maxOptions() {
      return this.listOptions.length >= 10;
    },
  },
  methods: {
    ...mapActions('AppSettingModule', ['requestAccountDeletionSurvey', 'requestSaveAccountDeletionSurvey']),
    del(scope) {
      this.listOptions.splice(scope.$index, 1);
    },
    async actionEdit() {
      if (this.isEdit) {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          await this.requestSaveAccountDeletionSurvey({
            title: this.title,
            description: this.description,
            options: this.listOptions.map(opt => ({ name: opt.name, show_text_field: opt.show_text_field })),
            status: 1,
          });
          if (this.getStatus === 200) {
            this.$swal('Account Deletion Survey Saved', '', 'success');
            await this.refineData();
            this.isEdit = false;
            this.$v.$reset();
          } else if (this.getStatus === 400 && this.getErrorCode === 'error-save-account-del-survey') {
            this.$swal('Error', this.getMessage, 'error');
          }
        }
      } else {
        this.isEdit = true;
        this.listOptions = [];
        this.listOptions = JSON.parse(JSON.stringify(this.listOriginOptions));
      }
    },
    cancelEdit() {
      this.isEdit = false;
      this.$v.$reset();
      this.listOptions = [];
      this.listOptions = JSON.parse(JSON.stringify(this.listOriginOptions));
    },
    addOption() {
      this.listOptions.push({
        id: this.lastId,
        name: '',
        show_text_field: false,
        new: true,
      });
      this.lastId = this.lastId + 1;
    },
    async refineData() {
      const data = await this.requestAccountDeletionSurvey();
      this.title = data.title;
      this.description = data.description;
      const options = [];
      let lastId = 0;
      data.options.forEach((opt, index) => {
        options.push({
          id: index,
          name: opt.name,
          show_text_field: opt.show_text_field,
          new: false,
        });
        lastId++;
      });
      this.lastId = lastId;
      this.listOriginOptions = JSON.parse(JSON.stringify(options));
      this.listOptions = JSON.parse(JSON.stringify(options));
    },
  },
  async mounted() {
    await this.refineData();
  },
  components: { TextArea, VueCustomTooltip, ElTableDraggable, Card, FormItem, Button, TextError, Input },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/AppSetting/AccountDeletionSurvey.vue